'use client'

import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import { usePageCSSClass } from './PageCSSClassContext'
import { wrapper } from './StoryblokLayout.css'

export function StoryblokLayoutWrapper({ children, className }: { children: ReactNode; className?: string }) {
  const { pageClass } = usePageCSSClass()
  return <div className={clsx(wrapper, className, pageClass)}>{children}</div>
}
